import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  SimpleChanges,
  OnChanges,
  Injector,
  inject,
} from '@angular/core';
import { takeUntil } from 'rxjs';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { TranslateService } from '@ngx-translate/core';
import { Nullable } from '@src/types/utils';
import { DialogConfirmComponent } from '@src/app/shared/dialogs';
import { BaseComponent } from '@src/app/modules/base';

import { ContactsCustomListItem } from '../../../types';
import { HeaderOptions } from '../../header/types';

@Component({
  selector: 'list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListViewComponent extends BaseComponent implements OnChanges {
  private readonly translateService = inject(TranslateService);
  private readonly dialogService = inject(TuiDialogService);
  private readonly injector = inject(Injector);

  @Input() listItems?: Nullable<Array<ContactsCustomListItem>>;
  @Input() headerTitle?: string;

  @Input() isParent = false;

  @Output() return = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();
  @Output() removeItem = new EventEmitter<string>();
  @Output() selectDirectory = new EventEmitter<ContactsCustomListItem>();

  headerOptions: HeaderOptions = {
    title: this.translateService.instant('components.contactsDirectory.labels.headerTitle'),
    buttons: {
      left: {
        label: this.translateService.instant('common.buttons.return'),
        icon: '@tui.chevron-left',
        visible: () => !this.isParent,
        action: () => {
          this.return.emit();
        },
      },
      right: {
        label: this.translateService.instant('common.buttons.change'),
        visible: () => true,
        action: () => {
          this.edit.emit();
        },
      },
    },
  };

  private readonly confirmDeleteDialog = this.dialogService.open<boolean>(
    new PolymorpheusComponent(DialogConfirmComponent, this.injector),
    {
      label: this.translateService.instant('common.dialogs.deleteHeader'),
      size: 's',
      closeable: false,
    },
  );

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.headerTitle && this.headerTitle) {
      this.headerOptions.title = this.headerTitle;
    }

    this.cdr.markForCheck();
  }

  onClickDeleteButton(item: ContactsCustomListItem) {
    this.confirmDeleteDialog.pipe(takeUntil(this.destroyed$$)).subscribe(res => {
      if (res && item.id) {
        this.removeItem.emit(item.id);
      }
    });
  }
}
